export { DOMOverlayRenderer } from './dom-modal-renderer';
export { Modal } from './modal';
export { DOMOutsideEventPlugin } from './outside-event-plugin';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-modal/esm/providers/index.js
// module id = ./node_modules/angular2-modal/esm/providers/index.js
// module chunks = vendor